var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":((_vm.label) ? _vm.label : 'Tipo de Multa') + ':',"placeholder":"Busca Tipo de Multa por Nome ou Código","funcaoBuscar":"getTiposMultaBox"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }